import { useTranslation } from 'react-i18next'

/** 中 / EN 切换：显示目标语言，点击切换 */
export function LangSwitch() {
  const { i18n, t } = useTranslation()
  const current = i18n.language.startsWith('zh') ? 'zh' : 'en'
  const next = current === 'zh' ? 'en' : 'zh'

  return (
    <button
      type="button"
      className="icon-btn"
      title={t('lang.switchTo')}
      aria-label={t('lang.switchTo')}
      onClick={() => void i18n.changeLanguage(next)}
    >
      {next === 'en' ? 'EN' : '中'}
    </button>
  )
}
